import config from '../../config/config';
import AuthHeader from '../../helpers/AuthHeader';

export const reportsService = {
  createReport
};

function handleResponse(response) {
	return response.clone().json()
		.then(json => {
			if (!response.ok) {
				if (response.status === 409) {
					json.status = 'running';
				} else {
					throw json;
				}
			} else {
				json.status = 'new';
			}
			return json;
		});
}

function createReport(url){
	const requestOptions = {
		  method: 'POST',
		  headers: AuthHeader({'Content-Type': 'application/json'}),
		  body: JSON.stringify({source: url})
	  };
		
	  let orthusUrl = `${config.apis.orthus}/v1/source_sql`;
	  return fetch(orthusUrl, requestOptions).then(handleResponse)
}

